<ejs-dialog cssClass="warningModal" #warningBoxDialog isModal="true" id='dialog' height='230px' width='450px'>
  <ng-template #header>
    <div class="d-flex justify-content-end">
      <span (click)="resumeEdit(true)" type="button" class="e-icons icon-variant30"></span>
    </div>
  </ng-template>
  <ng-template #content>
    <div class="d-flex flex-column justify-content-center align-items-center">
      <div class="title-dialog">{{title}}</div>
      <div class="message-div" [ngClass]="hasGap?'content-confirm':''">
        <div class="message">
          @if(message2.endsWith('as extracted?')){
          <ejs-checkbox [checked]="true" (change)="checkBoxChange($event)"></ejs-checkbox>
          }
          {{message1}}
        </div>
        @if (message2) {
        @if (title==='Submit Proposal') {
        <div class="hyper-link" (click)="openPDF()">{{message2}}</div>
        }@else {
        <div class="message">{{message2}}</div>
        }
        }
        @if (message3) {
        <div class="message">{{message3}}</div>
        }
      </div>
      <div class="btns">
        <button ejs-button cssClass="apply-btn" (click)="actionEmit()" type="button">{{actionBtn}}</button>
        @if (cancelBtn) {
        <button ejs-button cssClass="cancelBtn" (click)="resumeEdit(false)" type="button">{{cancelBtn}}</button>
        }
      </div>
    </div>
  </ng-template>
</ejs-dialog>

@if(isOpenPdf){
<ocado-pdf-viewer [pdfBase64Url]="pdfBase64Url || ''" (cancelBtnEvent)="pdfClosed()"></ocado-pdf-viewer>
}